<template>
  <el-card class="page-card" shadow="never">
    <template #header>
      <div class="card-header">
        <div class="header-icon">🏆</div>
        <div class="header-text">
          <span class="card-title">荣耀殿堂 / 政策图片管理</span>
          <span class="card-subtitle">维护各城市销售图集、课程安排、满分学员、家长锦旗及荣耀殿堂月度长图（荣耀殿堂需分别上传「头图」与「长图」：头图用于小程序首页弹框海报，长图用于点进去查看的大图）</span>
        </div>
      </div>
    </template>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-button type="primary" class="add-btn" @click="addDialog = true">
        <el-icon><Plus /></el-icon> 添加图片
      </el-button>
      <el-select v-model="query.regionFlag" placeholder="请选择类型" class="filter-select" clearable>
        <el-option label="全部类型" :value="0"></el-option>
        <el-option
            v-for="t in typeOptions" :key="t.value"
            :label="t.label" :value="t.value"/>
      </el-select>
      <el-select v-model="query.areaId" placeholder="请选择城市" class="filter-select" clearable>
        <el-option
            v-for="item in regionList" :key="item.id"
            :label="item.name" :value="item.id"/>
      </el-select>
      <el-button type="primary" plain icon="Search" @click="query.pageIndex = 1; getDataList()">搜索</el-button>
      <el-button icon="Refresh" @click="resetQuery">重置</el-button>
    </div>

    <el-divider class="filter-divider"></el-divider>

    <!-- 表格数据 -->
    <el-table
        :data="dataList" border class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        :row-class-name="rowClassName"
        v-loading="tableLoading"
        empty-text="暂无数据"
    >
      <el-table-column prop="regionName" label="适用城市" width="120" align="center"/>
      <el-table-column prop="regionFlag" label="类型" width="120" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.regionFlag == 8 ? 'warning' : 'info'" effect="plain" size="small">
            {{ typeLabel(scope.row.regionFlag) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="图集预览" min-width="140" align="center">
        <template #default="scope">
          <el-image
              v-if="scope.row.regionFlag == 8"
              class="thumb thumb-long"
              :src="scope.row.policyHeaderImage || getFirstBodyImage(scope.row)"
              :preview-src-list="getBodyImages(scope.row).length ? getBodyImages(scope.row) : [scope.row.policyHeaderImage]"
              :initial-index="0" fit="contain">
            <template #error>
              <div class="image-slot">暂无图片</div>
            </template>
          </el-image>
          <el-image
              v-else
              class="thumb"
              :src="scope.row.policyHeaderImage"
              :preview-src-list="[scope.row.policyHeaderImage]"
              fit="contain">
            <template #error>
              <div class="image-slot">暂无图片</div>
            </template>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center"/>
      <el-table-column prop="startTime" label="开始时间" width="120" align="center"/>
      <el-table-column prop="endTime" label="截止时间" width="120" align="center"/>
      <el-table-column prop="coachName" label="提交人" width="110" align="center"/>
      <el-table-column prop="policyState" label="状态" width="90" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.policyState == '开启' ? 'success' : 'danger'" effect="light" size="small">
            {{ scope.row.policyState == '开启' ? '开启' : '关闭' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="110" align="center">
        <template #default="scope">
          <el-tag
              :type="verifyTagType(scope.row.verifyState)"
              effect="light" size="small">
            {{ verifyLabel(scope.row.verifyState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="policyRemarks" label="申请说明" min-width="160" show-overflow-tooltip/>
      <el-table-column label="操作" width="90" align="center" fixed="right">
        <template #default="scope">
          <el-button type="danger" link @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="total"
          @current-change="handlePageChange"/>
    </div>

    <!-- 新增图集弹框 -->
    <el-dialog
        v-model="addDialog"
        title="添加政策图片"
        width="720px"
        @close="clearAddPhoto"
        :close-on-click-modal="false"
    >
      <el-form label-width="100px" class="add-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="图片类型" required>
              <el-select v-model="addPhoto.regionFlag" @change="onTypeChange" placeholder="请选择类型" style="width:100%">
                <el-option
                    v-for="t in typeOptions" :key="t.value"
                    :label="t.label" :value="t.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用城市">
              <el-select v-model="addPhoto.areaId" placeholder="请选择城市（不选=全集团）" style="width:100%" clearable>
                <el-option
                    v-for="item in regionList" :key="item.id"
                    :label="item.name" :value="item.id"/>
              </el-select>
              <div class="field-hint">不选则全集团所有城市均展示</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-date-picker
                  v-model="addPhoto.startTime"
                  type="date" placeholder="开始时间"
                  format="YYYY/MM/DD" value-format="YYYY-MM-DD"
                  style="width:100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截止时间">
              <el-date-picker
                  v-model="addPhoto.endTime"
                  type="date" placeholder="截止时间"
                  format="YYYY/MM/DD" value-format="YYYY-MM-DD"
                  style="width:100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 头图：所有类型共用，作为列表/小程序首屏弹框的封面海报 -->
        <el-form-item :label="addPhoto.regionFlag == 8 ? '头图（首页海报）' : '上传图片'" required>
          <div class="upload-wrap">
            <el-upload
                ref="upload"
                class="avatar-uploader"
                :http-request="uploadCardOmit"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemoveHeader"
                :limit="1"
                :class="{ hideUpload: addPhoto.policyHeaderImage }"
                list-type="picture-card"
                accept="image/*">
              <el-icon class="upload-plus"><Plus /></el-icon>
            </el-upload>
            <el-image
                v-if="addPhoto.policyHeaderImage"
                class="preview-img"
                :src="addPhoto.policyHeaderImage"
                :preview-src-list="[addPhoto.policyHeaderImage]"
                fit="contain"/>
          </div>
        </el-form-item>

        <!-- 长图：仅荣耀殿堂需要，作为小程序内点击查看的大图，与头图分开上传 -->
        <el-form-item v-if="addPhoto.regionFlag == 8" label="长图（查看大图）" required>
          <div class="upload-wrap">
            <el-upload
                ref="uploadBody"
                class="avatar-uploader"
                :http-request="uploadBodyOmit"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemoveBody"
                :limit="1"
                :class="{ hideUpload: addPhoto.policyBodyImages.length }"
                list-type="picture-card"
                accept="image/*">
              <el-icon class="upload-plus"><Plus /></el-icon>
            </el-upload>
            <el-image
                v-if="addPhoto.policyBodyImages.length"
                class="preview-img"
                :src="addPhoto.policyBodyImages[0]"
                :preview-src-list="addPhoto.policyBodyImages"
                fit="contain"/>
          </div>
          <el-alert
              class="glory-tip"
              type="warning" :closable="false" show-icon
              title="荣耀殿堂请分别上传：头图用于小程序首页弹框海报，长图用于点进去查看的大图，两者相互独立"/>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input
              v-model="addPhoto.policyRemarks"
              :rows="3" type="textarea"
              placeholder="请填写申请说明 / 原由"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addDialog = false">取消</el-button>
        <el-button type="primary" @click="confirm">确定提交</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>
<script>
import { getPageList, insertPolicyImages, deleteImage } from '@/api/policy'
import { selectAreaByExpress } from "@/api/area"
import { uploadImage } from '@/api/helpManual'

export default {
  data() {
    return {
      // 类型选项：筛选与新增共用，保证两端一致
      typeOptions: [
        { label: '销售图集', value: 1 },
        { label: '课程安排表', value: 2 },
        { label: '满分学员', value: 3 },
        { label: '家长锦旗', value: 4 },
        { label: '集团报表', value: 5 },
        { label: '考试政策', value: 6 },
        { label: '荣耀殿堂', value: 8 },
      ],
      addPhoto: {
        policyRemarks: '',
        startTime: '',
        endTime: '',
        areaId: null,
        regionFlag: null,
        policyBodyImages: [],
        policyTitle: '',
        policyContent: '',
        verifyState: 2,        // 图集审核状态：0待审核1审核中2审核通过3被拒绝
        policyHeaderImage: null,
        policyState: '开启',
        coachId: Number(localStorage.getItem('coachId')),
        createTime: ''
      },
      regionList: [],
      query: {
        areaId: null,
        pageIndex: 1,
        pageSize: 10,
        policyTitle: "",
        regionFlag: 0
      },
      total: 0,
      dataList: [],
      addDialog: false
    }
  },
  methods: {
    typeLabel(flag) {
      const t = this.typeOptions.find(i => i.value === flag)
      return t ? t.label : '未知'
    },
    verifyLabel(s) {
      return s == 0 ? '待审核' : s == 1 ? '审核中' : s == 2 ? '审核通过' : s == 3 ? '拒绝' : '未知'
    },
    verifyTagType(s) {
      return s == 0 ? 'info' : s == 1 ? 'warning' : s == 2 ? 'success' : 'danger'
    },
    rowClassName({ row }) {
      return row.regionFlag == 8 ? 'glory-row' : ''
    },
    // 解析长图：兼容 JSON 字符串与已解析数组
    parseBodyImages(val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      try {
        const arr = JSON.parse(val)
        return Array.isArray(arr) ? arr : []
      } catch (e) {
        return []
      }
    },
    getBodyImages(row) {
      return this.parseBodyImages(row.policyBodyImages)
    },
    getFirstBodyImage(row) {
      const arr = this.getBodyImages(row)
      return arr.length ? arr[0] : ''
    },
    resetQuery() {
      this.query.regionFlag = 0
      this.query.areaId = null
      this.query.pageIndex = 1
      this.getDataList()
    },
    handleDelete(id) {
      this.$confirm('确定删除该图集吗？删除后不可恢复。', '提示', {
        type: 'warning', confirmButtonText: '确定删除', cancelButtonText: '取消'
      }).then(() => {
        deleteImage(id).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getDataList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        })
      }).catch(() => {})
    },
    clearAddPhoto() {
      this.addPhoto = {
        policyRemarks: '',
        startTime: '',
        endTime: '',
        areaId: null,
        regionFlag: null,
        policyBodyImages: [],
        policyTitle: '',
        policyContent: '',
        verifyState: 2,
        policyHeaderImage: null,
        policyState: '开启',
        coachId: Number(localStorage.getItem('coachId')),
        createTime: ''
      }
      // 清理上传组件内部可能存在的失败缩略图
      if (this.$refs.upload) this.$refs.upload.clearFiles()
      if (this.$refs.uploadBody) this.$refs.uploadBody.clearFiles()
    },
    // 切换图片类型：非荣耀殿堂时清空长图，避免遗留数据被误用
    onTypeChange(val) {
      if (val != 8) {
        this.addPhoto.policyBodyImages = []
        if (this.$refs.uploadBody) this.$refs.uploadBody.clearFiles()
      }
    },
    getDataList() {
      getPageList(this.query).then(res => {
        if (res.code == 200) {
          this.dataList = res.data.records
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
      selectAreaByExpress().then(res => {
        if (res.code == 200) {
          this.regionList = res.data
        } else {
          this.$message.error("获取城市数据失败")
        }
      })
    },
    handlePageChange(e) {
      this.query.pageIndex = e
      this.getDataList()
    },
    getDate() {
      const now = new Date()
      const p = n => String(n).padStart(2, '0')
      this.addPhoto.createTime =
        `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())} ` +
        `${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`
    },
    confirm() {
      if (!this.addPhoto.regionFlag) {
        this.$message.warning('请选择图片类型')
        return
      }
      if (!this.addPhoto.policyHeaderImage) {
        this.$message.warning('请先上传头图')
        return
      }
      // 荣耀殿堂必须单独上传长图（点击查看的大图）
      if (this.addPhoto.regionFlag == 8 && !this.addPhoto.policyBodyImages.length) {
        this.$message.warning('荣耀殿堂请上传长图')
        return
      }
      this.getDate()
      const payload = { ...this.addPhoto }
      // 荣耀殿堂：头图与长图分开上传，各自独立存储
      // 其他类型：长图缺省等于头图，保持历史数据兼容
      payload.policyBodyImages = JSON.stringify(
        (this.addPhoto.regionFlag == 8 && this.addPhoto.policyBodyImages.length)
          ? this.addPhoto.policyBodyImages
          : (this.addPhoto.policyHeaderImage ? [this.addPhoto.policyHeaderImage] : [])
      )
      insertPolicyImages(payload).then(res => {
        if (res.code == 200) {
          this.addDialog = false
          this.$message.success('添加成功')
          this.getDataList()
        } else {
          this.$message.error(res.message || '添加失败')
        }
      })
    },
    // 上传前校验
    beforeAvatarUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传 JPG / PNG / WEBP 图片')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        return false
      }
      return true
    },
    // 移除头图：仅清空封面，长图不受影响
    handleRemoveHeader() {
      this.addPhoto.policyHeaderImage = null
    },
    // 移除长图：仅清空长图，头图不受影响
    handleRemoveBody() {
      this.addPhoto.policyBodyImages = []
    },
    // 自定义上传：头图（首页海报）
    async uploadCardOmit(file) {
      try {
        const url = await this.uploadImg(file)
        if (!url) {
          file.onError && file.onError()
          return
        }
        this.addPhoto.policyHeaderImage = url
        file.onSuccess && file.onSuccess({ url })
      } catch (e) {
        this.$message.warning('图片上传失败，请重试')
        if (this.$refs.upload) this.$refs.upload.clearFiles()
        file.onError && file.onError(e)
      }
    },
    // 自定义上传：长图（点击查看的大图）
    async uploadBodyOmit(file) {
      try {
        const url = await this.uploadImg(file)
        if (!url) {
          file.onError && file.onError()
          return
        }
        this.addPhoto.policyBodyImages = [url]
        file.onSuccess && file.onSuccess({ url })
      } catch (e) {
        this.$message.warning('图片上传失败，请重试')
        if (this.$refs.uploadBody) this.$refs.uploadBody.clearFiles()
        file.onError && file.onError(e)
      }
    },
    async uploadImg(file, retry = 2) {
      const data = new FormData()
      data.append('multipartFile', file.file)
      data.append('flag', 'policyHeaderImage')
      data.append('fileName', file.file.name)
      // 网络/MinIO 偶发抖动时自动重试，减少手动重试次数
      for (let i = 0; i <= retry; i++) {
        try {
          const res = await uploadImage(data)
          if (res && res.code == 200) return res.data
        } catch (e) {
          // 网络异常，进入下一次重试
        }
      }
      return null
    }
  },
  created() {
    this.getDataList()
  }
}
</script>
<style scoped>
.page-card {
  margin: 16px;
  border-radius: 12px;
  border: none;
}

/* 头部 */
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1f2a52, #3a2a5e);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}
.header-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2a52;
}
.card-subtitle {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-select {
  width: 160px;
}
.filter-divider {
  margin: 14px 0;
}

/* 表格 */
.table {
  border-radius: 8px;
  overflow: hidden;
}
.table-header th {
  background: #f5f7fa !important;
  color: #303133;
  font-weight: 600;
}
.glory-row {
  background: #fdf8ec !important;
}
.glory-row:hover > td {
  background: #fbf0d3 !important;
}
.thumb {
  width: 70px;
  height: 70px;
  border-radius: 6px;
}
.thumb-long {
  width: 60px;
  height: 90px;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #c0c4cc;
  background: #f5f7fa;
  border-radius: 6px;
}

/* 分页 */
.pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* 新增弹框 */
.add-form {
  padding: 8px 4px;
}
.field-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.4;
}
.upload-wrap {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.preview-img {
  max-height: 220px;
  max-width: 220px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  padding: 4px;
  background: #fff;
}
.glory-tip {
  margin-top: 10px;
  line-height: 1.5;
}

/* 上传卡片尺寸 */
.avatar-uploader :deep(.el-upload--picture-card) {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.avatar-uploader :deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 100px;
  height: 100px;
}
.avatar-uploader :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.upload-plus {
  font-size: 26px;
  color: #8c8c8c;
}
/* 已有图片时隐藏上传按钮 */
.hideUpload :deep(.el-upload--picture-card) {
  display: none !important;
}
</style>
